import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "nerriPasswordRuleClass"
})
export class PasswordRuleClassPipe implements PipeTransform {
    public transform(rule: boolean | null): Record<string, boolean> {
        return {
            invalid: rule === false,
            valid: rule === true
        };
    }
}
